import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=2e7a1c18&"
import script from "./channel.vue?vue&type=script&lang=ts&"
export * from "./channel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports